export enum Currency {
  SEK = 'SEK',
  EUR = 'EUR',
}

export const CurrencyText = {
  [Currency.SEK]: 'Kronor (Svenska)',
  [Currency.EUR]: 'Euro',
};

export const CurrencySymbol = {
  [Currency.SEK]: 'kr',
  [Currency.EUR]: '€',
};
